(function () {
    'use strict';
    var ctrl = function () {
        var model = this;
    }
    //app.controller('adminCtrl', ctrl);
})();
